const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 343,
    height: 63,
    viewBox: "0 0 343 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "07blwj3zva"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3418",
    transform: "translate(16 1607)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h343v63H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1",
    transform: "translate(-16 -1607)",
    style: {
      clipPath: "url(#07blwj3zva)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5037",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5038"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13410",
    d: "M3429.273 220.867h-13.937a.659.659 0 0 1-.659-.659 2.924 2.924 0 0 1 2.379-2.872 5.238 5.238 0 0 1 9.082-1.015 3.992 3.992 0 0 1 3.794 3.867.66.66 0 0 1-.659.679m-13.138-1.319h12.37a2.677 2.677 0 0 0-2.563-1.913h-.132a.66.66 0 0 1-.593-.314 3.918 3.918 0 0 0-7.064.826.66.66 0 0 1-.607.454 1.6 1.6 0 0 0-1.416.943",
    transform: "translate(-3392.39 1402.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13411",
    d: "M197.872 129.725h-11.739a.659.659 0 0 1-.659-.659 2.895 2.895 0 0 1 2.35-2.842 5.178 5.178 0 0 1 8.975-1 3.952 3.952 0 0 1 3.028 1.666.659.659 0 0 1-1.077.762 2.637 2.637 0 0 0-2.174-1.113h-.1a.665.665 0 0 1-.6-.313 3.859 3.859 0 0 0-6.957.813.659.659 0 0 1-.607.454 1.566 1.566 0 0 0-1.385.914h10.937a.659.659 0 0 1 0 1.319",
    transform: "translate(-333.541 1488.335)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13412",
    d: "M383.926 191.817h-11.007a.659.659 0 0 1-.659-.659 2.433 2.433 0 0 1 1.919-2.39 4.275 4.275 0 0 1 7.344-.814 3.292 3.292 0 0 1 3.062 3.185.659.659 0 0 1-.659.679m-10.137-1.318h9.338a1.962 1.962 0 0 0-1.831-1.234h-.093a.662.662 0 0 1-.6-.314 2.956 2.956 0 0 0-5.329.623.66.66 0 0 1-.607.454 1.122 1.122 0 0 0-.884.468",
    transform: "translate(-510.474 1428.506)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13431",
    d: "M1489.868 376.281h-25.749a.659.659 0 0 1-.659-.659v-33.95a.659.659 0 0 1 .659-.659h25.749a.659.659 0 0 1 .659.659v33.949a.659.659 0 0 1-.659.659m-25.089-1.319h24.43v-32.63h-24.43z",
    transform: "translate(-1544.108 1281.882)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13432",
    d: "M1489.868 456.1h-25.749a.659.659 0 0 1-.659-.659V453.1a.659.659 0 0 1 .659-.659h25.749a.659.659 0 0 1 .659.659v2.335a.659.659 0 0 1-.659.659m-25.089-1.319h24.43v-1.016h-24.43z",
    transform: "translate(-1544.108 1176.332)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13433",
    d: "M1489.868 644.3h-25.749a.659.659 0 0 1-.659-.659v-2.335a.659.659 0 0 1 .659-.659h25.749a.659.659 0 0 1 .659.659v2.335a.659.659 0 0 1-.659.659m-25.089-1.319h24.43v-1.016h-24.43z",
    transform: "translate(-1544.108 998.055)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13434",
    d: "M1489.868 832.506h-25.749a.659.659 0 0 1-.659-.659v-2.335a.659.659 0 0 1 .659-.659h25.749a.659.659 0 0 1 .659.659v2.335a.659.659 0 0 1-.659.659m-25.089-1.319h24.43v-1.016h-24.43z",
    transform: "translate(-1544.108 819.779)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13435",
    d: "M1568.815 261.938h-16.437a.659.659 0 0 1-.659-.659V256.8a.659.659 0 0 1 .659-.659h16.437a.659.659 0 0 1 .659.659v4.477a.659.659 0 0 1-.659.659m-15.777-1.319h15.118v-3.158h-15.118z",
    transform: "translate(-1627.711 1362.276)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13436",
    d: "M1611.848 180.726h-11.361a.659.659 0 0 1-.659-.659v-4.274a.659.659 0 0 1 .659-.659h11.361a.659.659 0 0 1 .659.659v4.274a.659.659 0 0 1-.659.659m-10.7-1.319h10.042v-2.955h-10.042z",
    transform: "translate(-1673.282 1439.01)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13437",
    d: "M1438.355 997.86h-31.825a.659.659 0 0 1-.659-.659v-12a.659.659 0 0 1 .659-.659h31.825a.659.659 0 0 1 .659.659v12a.659.659 0 0 1-.659.659m-31.166-1.319h30.511v-10.68h-30.51z",
    transform: "translate(-1489.557 672.302)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13438",
    d: "M1469.024 1050.046h-4.9a.659.659 0 0 1-.659-.659v-9.092a.659.659 0 0 1 .659-.659h4.9a.659.659 0 0 1 .66.659v9.092a.659.659 0 0 1-.66.659m-4.245-1.319h3.586v-7.774h-3.586z",
    transform: "translate(-1544.108 620.116)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13439",
    d: "M1864.147 1050.046h-4.9a.659.659 0 0 1-.659-.659v-9.092a.659.659 0 0 1 .659-.659h4.9a.659.659 0 0 1 .659.659v9.092a.659.659 0 0 1-.659.659m-4.245-1.319h3.586v-7.774h-3.588z",
    transform: "translate(-1918.387 620.116)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13440",
    d: "M1666.585 1050.046h-4.9a.659.659 0 0 1-.66-.659v-9.092a.659.659 0 0 1 .66-.659h4.9a.659.659 0 0 1 .659.659v9.092a.659.659 0 0 1-.659.659m-4.245-1.319h3.585v-7.774h-3.585z",
    transform: "translate(-1731.247 620.116)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13441",
    d: "M1708.165 78.939a.659.659 0 0 1-.659-.659v-5.342a.659.659 0 1 1 1.319 0v5.341a.659.659 0 0 1-.659.659",
    transform: "translate(-1775.279 1536.439)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13442",
    d: "M1553.633 376.011a.659.659 0 0 1-.659-.659v-33.68a.659.659 0 0 1 1.319 0v33.679a.659.659 0 0 1-.659.659",
    transform: "translate(-1628.9 1281.882)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13443",
    d: "M1862.694 376.011a.659.659 0 0 1-.659-.659v-33.68a.659.659 0 0 1 1.319 0v33.679a.659.659 0 0 1-.659.659",
    transform: "translate(-1921.656 1281.882)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13444",
    d: "M1656.654 376.011a.66.66 0 0 1-.659-.659v-33.68a.659.659 0 0 1 1.319 0v33.679a.659.659 0 0 1-.659.659",
    transform: "translate(-1726.486 1281.882)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13445",
    d: "M1759.675 376.011a.66.66 0 0 1-.66-.659v-33.68a.659.659 0 1 1 1.319 0v33.679a.659.659 0 0 1-.659.659",
    transform: "translate(-1824.071 1281.882)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13446",
    d: "M996.706 334.516h-16.957a.659.659 0 0 1-.659-.659v-5.791a.659.659 0 0 1 .659-.659h16.957a.659.659 0 0 1 .659.659v5.791a.659.659 0 0 1-.659.659m-16.3-1.319h15.638v-4.472h-15.635z",
    transform: "translate(-1085.291 1294.771)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13447",
    d: "M902.465 479.372h-28.073a.659.659 0 0 1-.659-.659v-40.875a.659.659 0 0 1 .659-.659h28.073a.659.659 0 0 1 .659.659v40.875a.659.659 0 0 1-.659.659m-27.413-1.319h26.754V438.5h-26.754z",
    transform: "translate(-985.492 1190.789)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13448",
    d: "M1054.5 279.13h-10.14a.659.659 0 0 1-.586-.962l1.423-2.762a.66.66 0 0 1 .586-.357h7.151a.659.659 0 0 1 .574.334l1.566 2.762a.659.659 0 0 1-.574.985m-9.058-1.319h7.927l-.818-1.443h-6.365z",
    transform: "translate(-1146.489 1344.366)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13449",
    d: "M1081.043 124.5h-7.009a.659.659 0 0 1-.659-.659v-4.628a.66.66 0 0 1 .173-.445l3.5-3.83a.659.659 0 0 1 .973 0l3.5 3.83a.659.659 0 0 1 .173.445v4.628a.659.659 0 0 1-.66.659m-6.349-1.319h5.69v-3.712l-2.845-3.109-2.845 3.109z",
    transform: "translate(-1174.602 1496.238)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13450",
    d: "M1140.461 78.1a.659.659 0 0 1-.659-.659v-13.85a.659.659 0 1 1 1.319 0v13.853a.659.659 0 0 1-.659.659",
    transform: "translate(-1237.524 1545.293)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13451",
    d: "M938.657 501.272h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319H938v-2.217h-1.1z",
    transform: "translate(-1044.075 1134.677)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13452",
    d: "M1029.307 501.272h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.217h-1.1z",
    transform: "translate(-1129.943 1134.677)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13453",
    d: "M1119.957 501.272h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.217h-1.1z",
    transform: "translate(-1215.811 1134.677)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13454",
    d: "M1210.607 501.272h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.66.66 0 0 1 .66.659v3.536a.66.66 0 0 1-.66.659m-1.759-1.319h1.1v-2.217h-1.1z",
    transform: "translate(-1301.679 1134.677)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13455",
    d: "M1301.257 501.272h-2.418a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.418a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.217h-1.1z",
    transform: "translate(-1387.546 1134.677)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13456",
    d: "M938.657 614.986h-2.419a.659.659 0 0 1-.659-.659v-3.537a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319H938v-2.216h-1.1z",
    transform: "translate(-1044.075 1026.961)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13457",
    d: "M1029.307 614.986h-2.419a.659.659 0 0 1-.659-.659v-3.537a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.216h-1.1z",
    transform: "translate(-1129.943 1026.961)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13458",
    d: "M1119.957 614.986h-2.419a.659.659 0 0 1-.659-.659v-3.537a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.216h-1.1z",
    transform: "translate(-1215.811 1026.961)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13459",
    d: "M1210.607 614.986h-2.419a.659.659 0 0 1-.659-.659v-3.537a.659.659 0 0 1 .659-.659h2.419a.66.66 0 0 1 .66.659v3.536a.66.66 0 0 1-.66.659m-1.759-1.319h1.1v-2.216h-1.1z",
    transform: "translate(-1301.679 1026.961)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13460",
    d: "M1301.257 614.986h-2.418a.659.659 0 0 1-.659-.659v-3.537a.659.659 0 0 1 .659-.659h2.418a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.216h-1.1z",
    transform: "translate(-1387.546 1026.961)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13461",
    d: "M938.657 842.412h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319H938v-2.217h-1.1z",
    transform: "translate(-1044.075 811.533)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13462",
    d: "M1029.307 842.412h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.217h-1.1z",
    transform: "translate(-1129.943 811.533)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13463",
    d: "M1119.957 842.412h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.217h-1.1z",
    transform: "translate(-1215.811 811.533)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13464",
    d: "M1210.607 842.412h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.66.66 0 0 1 .66.659v3.536a.66.66 0 0 1-.66.659m-1.759-1.319h1.1v-2.217h-1.1z",
    transform: "translate(-1301.679 811.533)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13465",
    d: "M1301.257 842.412h-2.418a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.418a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.217h-1.1z",
    transform: "translate(-1387.546 811.533)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13466",
    d: "M938.657 1069.839h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319H938v-2.22h-1.1z",
    transform: "translate(-1044.075 596.104)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13467",
    d: "M1029.307 1069.839h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.22h-1.1z",
    transform: "translate(-1129.943 596.104)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13468",
    d: "M1119.957 1069.839h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.22h-1.1z",
    transform: "translate(-1215.811 596.104)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13469",
    d: "M1210.607 1069.839h-2.419a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.419a.66.66 0 0 1 .66.659v3.536a.66.66 0 0 1-.66.659m-1.759-1.319h1.1v-2.22h-1.1z",
    transform: "translate(-1301.679 596.104)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13470",
    d: "M1301.257 1069.839h-2.418a.659.659 0 0 1-.659-.659v-3.536a.659.659 0 0 1 .659-.659h2.418a.659.659 0 0 1 .659.659v3.536a.659.659 0 0 1-.659.659m-1.759-1.319h1.1v-2.22h-1.1z",
    transform: "translate(-1387.546 596.104)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13471",
    d: "M957.785 725.163h-21.548a.659.659 0 0 1 0-1.319h21.547a.659.659 0 0 1 0 1.319",
    transform: "translate(-1044.074 919.247)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13472",
    d: "M957.785 792.189h-21.548a.659.659 0 0 1 0-1.319h21.547a.659.659 0 0 1 0 1.319",
    transform: "translate(-1044.074 855.757)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13473",
    d: "M957.785 758.676h-21.548a.659.659 0 1 1 0-1.319h21.547a.659.659 0 1 1 0 1.319",
    transform: "translate(-1044.074 887.502)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13474",
    d: "M1042.281 366.855H1030.7a.659.659 0 1 1 0-1.319h11.581a.659.659 0 1 1 0 1.319",
    transform: "translate(-1133.554 1258.653)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13475",
    d: "M1042.281 400.368H1030.7a.659.659 0 0 1 0-1.319h11.581a.659.659 0 0 1 0 1.319",
    transform: "translate(-1133.554 1226.908)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13476",
    d: "M957.785 952.59h-21.548a.659.659 0 0 1 0-1.319h21.547a.659.659 0 0 1 0 1.319",
    transform: "translate(-1044.074 703.818)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13477",
    d: "M957.785 1019.616h-21.548a.659.659 0 0 1 0-1.319h21.547a.659.659 0 0 1 0 1.319",
    transform: "translate(-1044.074 640.328)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13478",
    d: "M957.785 986.1h-21.548a.659.659 0 1 1 0-1.319h21.547a.659.659 0 1 1 0 1.319",
    transform: "translate(-1044.074 672.074)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13479",
    d: "M2209.508 38a.66.66 0 0 1-.576-.979c.959-1.73 3.712-2.893 6.848-2.893a.659.659 0 1 1 0 1.319 9.739 9.739 0 0 0-3.684.672 4 4 0 0 0-2.011 1.541.659.659 0 0 1-.577.34",
    transform: "translate(-2250.175 1572.574)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13480",
    d: "M2334.66 38a.659.659 0 0 1-.577-.34 4 4 0 0 0-2.011-1.541 9.739 9.739 0 0 0-3.684-.672.659.659 0 0 1 0-1.319c3.136 0 5.888 1.162 6.848 2.893a.66.66 0 0 1-.576.979",
    transform: "translate(-2362.783 1572.574)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13481",
    d: "M2233.4 97.589h-11.2a.66.66 0 0 1-.659-.659v-60.4a.66.66 0 0 1 .218-.489 10.55 10.55 0 0 1 12.089 0 .66.66 0 0 1 .218.489v60.4a.66.66 0 0 1-.66.659m-10.545-1.319h9.886V36.833a9.535 9.535 0 0 0-9.886 0z",
    transform: "translate(-2262.189 1572.573)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13482",
    d: "M2445.789 287.79h-11.2a.66.66 0 0 1-.66-.659v-47.7a.66.66 0 0 1 .134-.4 9.827 9.827 0 0 1 2.4-2.081 13.32 13.32 0 0 1 7.237-2.028 16.784 16.784 0 0 1 2.175.145.659.659 0 0 1 .573.654v51.4a.659.659 0 0 1-.659.659m-10.545-1.319h9.885v-50.146a15.147 15.147 0 0 0-1.43-.069 11.248 11.248 0 0 0-8.456 3.428z",
    transform: "translate(-2463.377 1382.372)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13483",
    d: "M2647.707 238.988a.663.663 0 0 1-.083-.005l-.729-.091a.659.659 0 1 1 .164-1.309l.729.091a.659.659 0 0 1-.081 1.314",
    transform: "translate(-2664.565 1379.861)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13484",
    d: "M2021 287.79h-11.2a.66.66 0 0 1-.66-.659v-51.4a.659.659 0 0 1 .574-.654 16.781 16.781 0 0 1 2.175-.145 13.463 13.463 0 0 1 7.237 2.028 9.843 9.843 0 0 1 2.4 2.081.66.66 0 0 1 .134.4v47.7a.659.659 0 0 1-.659.659m-10.545-1.319h9.886v-46.8a9.444 9.444 0 0 0-1.98-1.641 11.92 11.92 0 0 0-6.475-1.788c-.467 0-.946.023-1.43.069z",
    transform: "translate(-2061 1382.372)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13485",
    d: "M1995.984 238.988a.659.659 0 0 1-.081-1.314l.729-.091a.659.659 0 1 1 .164 1.309l-.729.091a.666.666 0 0 1-.083.005",
    transform: "translate(-2047.915 1379.86)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13486",
    d: "M2257.805 192h-1.52a.66.66 0 0 1-.659-.659v-4.732a.66.66 0 0 1 .659-.659h1.52a.659.659 0 0 1 .659.659v4.732a.659.659 0 0 1-.659.659m-.86-1.319h.2v-3.413h-.2z",
    transform: "translate(-2294.484 1428.765)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13487",
    d: "M2315.506 192h-1.52a.659.659 0 0 1-.659-.659v-4.732a.659.659 0 0 1 .659-.659h1.52a.659.659 0 0 1 .659.659v4.732a.659.659 0 0 1-.659.659m-.86-1.319h.2v-3.413h-.2z",
    transform: "translate(-2349.141 1428.765)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13488",
    d: "M2373.2 192h-1.52a.66.66 0 0 1-.659-.659v-4.732a.66.66 0 0 1 .659-.659h1.52a.66.66 0 0 1 .659.659v4.732a.66.66 0 0 1-.659.659m-.86-1.319h.2v-3.413h-.2z",
    transform: "translate(-2403.796 1428.765)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13489",
    d: "M2257.805 344.5h-1.52a.66.66 0 0 1-.659-.659V339.1a.66.66 0 0 1 .659-.659h1.52a.659.659 0 0 1 .659.659v4.732a.659.659 0 0 1-.659.659m-.86-1.319h.2v-3.413h-.2z",
    transform: "translate(-2294.484 1284.315)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13490",
    d: "M2315.506 344.5h-1.52a.659.659 0 0 1-.659-.659V339.1a.659.659 0 0 1 .659-.659h1.52a.659.659 0 0 1 .659.659v4.732a.659.659 0 0 1-.659.659m-.86-1.319h.2v-3.413h-.2z",
    transform: "translate(-2349.141 1284.315)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13491",
    d: "M2373.2 344.5h-1.52a.66.66 0 0 1-.659-.659V339.1a.66.66 0 0 1 .659-.659h1.52a.66.66 0 0 1 .659.659v4.732a.66.66 0 0 1-.659.659m-.86-1.319h.2v-3.413h-.2z",
    transform: "translate(-2403.796 1284.315)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13492",
    d: "M2114.783 359.607a.659.659 0 0 1-.659-.659v-45.414a.659.659 0 0 1 1.319 0v45.414a.66.66 0 0 1-.659.659",
    transform: "translate(-2160.447 1308.536)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13493",
    d: "M2292.366 521.569a.659.659 0 0 1-.659-.659v-36.394a.659.659 0 1 1 1.319 0v36.394a.66.66 0 0 1-.659.659",
    transform: "translate(-2328.662 1146.574)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13494",
    d: "M2364.411 521.569a.66.66 0 0 1-.66-.659v-36.394a.659.659 0 1 1 1.319 0v36.394a.659.659 0 0 1-.659.659",
    transform: "translate(-2396.905 1146.574)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13495",
    d: "M2548.455 359.607a.66.66 0 0 1-.659-.659v-45.414a.659.659 0 0 1 1.319 0v45.414a.66.66 0 0 1-.659.659",
    transform: "translate(-2571.241 1308.536)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13496",
    d: "M2246.979 529.407h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2284.685 1104.676)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13497",
    d: "M2318.615 529.407h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2352.541 1104.676)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13498",
    d: "M2390.252 529.407h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2420.4 1104.676)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13499",
    d: "M2246.979 615.493h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2284.685 1023.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13500",
    d: "M2318.615 615.493h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2352.541 1023.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13501",
    d: "M2390.252 615.493h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2420.4 1023.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13502",
    d: "M2246.979 701.577h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2284.685 941.589)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13503",
    d: "M2318.615 701.577h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2352.541 941.589)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13504",
    d: "M2390.252 701.577h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2420.4 941.589)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13505",
    d: "M2246.979 787.663h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2284.685 860.044)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13506",
    d: "M2318.615 787.663h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2352.541 860.044)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13507",
    d: "M2390.252 787.663h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2420.4 860.044)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13508",
    d: "M2246.979 873.748h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2284.685 778.501)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13509",
    d: "M2318.615 873.748h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2352.541 778.501)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13510",
    d: "M2390.252 873.748h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2420.4 778.501)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13511",
    d: "M2246.979 959.833h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2284.685 696.957)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13512",
    d: "M2318.615 959.833h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2352.541 696.957)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13513",
    d: "M2390.252 959.833h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2420.4 696.957)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13514",
    d: "M2246.979 1045.918h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2284.685 615.414)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13515",
    d: "M2318.615 1045.918h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2352.541 615.414)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13516",
    d: "M2390.252 1045.918h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2420.4 615.414)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13517",
    d: "M2246.979 1132h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2284.685 533.869)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13518",
    d: "M2318.615 1132h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2352.541 533.869)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13519",
    d: "M2390.252 1132h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2420.4 533.869)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13520",
    d: "M2069.4 357.237h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2116.47 1267.764)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13521",
    d: "M2141.032 357.237h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 1267.764)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13522",
    d: "M2069.4 443.322h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2116.47 1186.22)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13523",
    d: "M2141.032 443.322h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 1186.22)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13524",
    d: "M2069.4 529.407h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2116.47 1104.676)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13525",
    d: "M2141.032 529.407h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 1104.676)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13526",
    d: "M2069.4 615.493h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2116.47 1023.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13527",
    d: "M2141.032 615.493h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 1023.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13528",
    d: "M2069.4 701.577h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2116.47 941.589)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13529",
    d: "M2141.032 701.577h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 941.589)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13530",
    d: "M2069.4 787.663h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2116.47 860.044)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13531",
    d: "M2141.032 787.663h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 860.044)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13532",
    d: "M2069.4 873.748h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2116.47 778.501)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13533",
    d: "M2141.032 873.748h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 778.501)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13534",
    d: "M2069.4 959.833h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2116.47 696.957)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13535",
    d: "M2141.032 959.833h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 696.957)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13536",
    d: "M2069.4 1045.918h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2116.47 615.414)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13537",
    d: "M2141.032 1045.918h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 615.414)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13538",
    d: "M2069.4 1132h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2116.47 533.869)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13539",
    d: "M2141.032 1132h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2184.328 533.869)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13540",
    d: "M2503.068 357.237h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2527.264 1267.764)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13541",
    d: "M2574.706 357.237h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 1267.764)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13542",
    d: "M2503.068 443.322h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2527.264 1186.22)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13543",
    d: "M2574.706 443.322h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 1186.22)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13544",
    d: "M2503.068 529.407h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2527.264 1104.676)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13545",
    d: "M2574.706 529.407h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 1104.676)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13546",
    d: "M2503.068 615.493h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2527.264 1023.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13547",
    d: "M2574.706 615.493h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 1023.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13548",
    d: "M2503.068 701.577h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2527.264 941.589)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13549",
    d: "M2574.706 701.577h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 941.589)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13550",
    d: "M2503.068 787.663h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2527.264 860.044)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13551",
    d: "M2574.706 787.663h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 860.044)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13552",
    d: "M2503.068 873.748h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 1 1 0 1.319",
    transform: "translate(-2527.264 778.501)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13553",
    d: "M2574.706 873.748h-1.038a.659.659 0 1 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 778.501)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13554",
    d: "M2503.068 959.833h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2527.264 696.957)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13555",
    d: "M2574.706 959.833h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 696.957)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13556",
    d: "M2503.068 1045.918h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2527.264 615.414)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13557",
    d: "M2574.706 1045.918h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 615.414)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13558",
    d: "M2503.068 1132h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2527.264 533.869)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13559",
    d: "M2574.706 1132h-1.038a.659.659 0 0 1 0-1.319h1.038a.659.659 0 0 1 0 1.319",
    transform: "translate(-2595.123 533.869)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13560",
    d: "M2233.715 128.352h-11.079a.659.659 0 0 1 0-1.319h11.079a.659.659 0 0 1 0 1.319",
    transform: "translate(-2262.61 1484.574)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13561",
    d: "M10.111 684.816a9.737 9.737 0 1 1 7.063-16.434.659.659 0 0 1-.957.908 8.341 8.341 0 0 0-6.107-2.625 8.415 8.415 0 1 0 7.916 11.281.659.659 0 1 1 1.24.449 9.738 9.738 0 0 1-9.156 6.421",
    transform: "translate(-158.208 974.658)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13562",
    d: "M173.065 765.465a.659.659 0 0 1-.659-.659v-24.941a.659.659 0 0 1 1.319 0v24.941a.659.659 0 0 1-.659.659",
    transform: "translate(-321.163 904.697)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13563",
    d: "M79.7 841.226a.657.657 0 0 1-.466-.193l-5.227-5.227a.659.659 0 1 1 .933-.933l4.761 4.761 4.761-4.761a.659.659 0 0 1 .933.933l-5.227 5.227a.657.657 0 0 1-.466.193",
    transform: "translate(-227.773 814.259)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13564",
    d: "M132 774.713a.659.659 0 0 1-.466-.193l-2.315-2.315a.659.659 0 1 1 .933-.932l1.848 1.848 1.849-1.849a.659.659 0 0 1 .933.933l-2.315 2.315a.659.659 0 0 1-.466.193",
    transform: "translate(-280.071 874.504)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13565",
    d: "M308.507 546.311a13.372 13.372 0 1 1 9.455-3.917 13.285 13.285 0 0 1-9.455 3.917m0-25.425a12.053 12.053 0 1 0 8.523 3.53 11.974 11.974 0 0 0-8.523-3.53",
    transform: "translate(-437.417 1112.748)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13566",
    d: "M536.77 627.375a.659.659 0 0 1-.659-.659v-32.633a.659.659 0 0 1 1.319 0v32.632a.659.659 0 0 1-.659.659",
    transform: "translate(-665.681 1042.787)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13567",
    d: "M366.05 750.6a.659.659 0 0 1-.466-.193l-9.48-9.48a.659.659 0 0 1 .933-.933L366.05 749l9.014-9.014a.659.659 0 0 1 .933.933l-9.48 9.48a.659.659 0 0 1-.466.193",
    transform: "translate(-494.986 904.136)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13568",
    d: "M442.409 695.443a.66.66 0 0 1-.466-.193l-5.227-5.227a.659.659 0 0 1 .933-.933l4.761 4.761 4.761-4.761a.659.659 0 0 1 .933.933l-5.227 5.227a.66.66 0 0 1-.466.193",
    transform: "translate(-571.346 952.351)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13569",
    d: "M494.705 628.932a.657.657 0 0 1-.466-.193l-2.315-2.315a.659.659 0 0 1 .933-.933l1.849 1.849 1.849-1.849a.659.659 0 0 1 .933.933l-2.315 2.315a.657.657 0 0 1-.466.193",
    transform: "translate(-623.642 1012.595)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13570",
    d: "M2969.7 469.9a4.305 4.305 0 0 1-2.679-.9 4.11 4.11 0 0 1-1.487-2.35.66.66 0 0 1 1.286-.295 2.873 2.873 0 0 0 2.88 2.227 3 3 0 0 0 2.969-2.6.66.66 0 0 1 .576-.568 4.562 4.562 0 0 0 1.639-8.536.66.66 0 0 1-.247-.923 4.563 4.563 0 0 0-5.834-6.507.659.659 0 0 1-.9-.378 6.521 6.521 0 0 0-12.306 0 .66.66 0 0 1-.9.378 4.518 4.518 0 0 0-1.941-.433 4.562 4.562 0 0 0-3.893 6.94.66.66 0 0 1-.247.923 4.562 4.562 0 0 0 1.638 8.536.659.659 0 0 1 .576.568 3 3 0 0 0 2.969 2.6 2.893 2.893 0 0 0 2.916-2.2.66.66 0 1 1 1.284.3 4.054 4.054 0 0 1-1.516 2.333 4.4 4.4 0 0 1-2.684.88 4.328 4.328 0 0 1-4.182-3.251 5.881 5.881 0 0 1-2.191-10.581 5.884 5.884 0 0 1 7.184-8.071 7.84 7.84 0 0 1 14.284 0 5.882 5.882 0 0 1 7.184 8.071 5.882 5.882 0 0 1-2.19 10.581 4.328 4.328 0 0 1-4.182 3.251",
    transform: "translate(-2947.409 1184.906)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13571",
    d: "M3094.81 809.443h-2.2a.659.659 0 0 1-.659-.688l.666-15.473-6.524-6.524a.659.659 0 0 1 .932-.932l6.729 6.729a.659.659 0 0 1 .192.495l-.649 15.075h1.516a.659.659 0 0 1 0 1.319",
    transform: "translate(-3080.953 860.719)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13572",
    d: "M3112.4 743.795a.66.66 0 0 1-.437-.166l-2.055-1.822a.659.659 0 0 1 .875-.987l.521.462-.325-1.432a.659.659 0 1 1 1.286-.292l.778 3.431a.659.659 0 0 1-.643.805",
    transform: "translate(-3103.488 904.848)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13573",
    d: "M3156.748 712.721a.659.659 0 0 1-.438-.166l-2-1.774a.66.66 0 0 1-.2-.322l-1.38-5.12A.659.659 0 0 1 3154 705l1.329 4.929.851.754.5-7.19a.659.659 0 1 1 1.315.091l-.588 8.527a.66.66 0 0 1-.658.614",
    transform: "translate(-3144.239 939.11)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13574",
    d: "M3208.3 689.219a4.318 4.318 0 0 0-5.179 0 .659.659 0 0 1 0-1.319 2.975 2.975 0 0 0 2.122-.882.66.66 0 0 1 .935 0 2.974 2.974 0 0 0 2.122.882.659.659 0 0 1 0 1.319",
    transform: "translate(-3191.373 954.314)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13575",
    d: "M3139.219 709.92a3.187 3.187 0 0 1-1.463-.356.659.659 0 1 1 .6-1.173 1.891 1.891 0 0 0 2.544-.814.659.659 0 1 1 1.172.6 3.211 3.211 0 0 1-2.857 1.739",
    transform: "translate(-3129.738 934.995)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13576",
    d: "M3017.495 732.766a5.7 5.7 0 0 1-1.877-.319.659.659 0 0 1 .434-1.245 4.409 4.409 0 0 0 5.608-2.711.659.659 0 0 1 1.246.434 5.734 5.734 0 0 1-5.41 3.841",
    transform: "translate(-3013.963 915.265)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13577",
    d: "M3246.257 809.443h-3.226a.659.659 0 0 1 0-1.319h2.537l-.649-15.075a.658.658 0 0 1 .193-.495l6.729-6.729a.659.659 0 1 1 .933.932l-6.524 6.524.667 15.473a.659.659 0 0 1-.659.688",
    transform: "translate(-3229.175 860.719)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13578",
    d: "M3356.116 743.8a.66.66 0 0 1-.643-.805l.778-3.431a.659.659 0 0 1 1.286.292l-.325 1.432.521-.462a.659.659 0 1 1 .875.987l-2.055 1.822a.66.66 0 0 1-.438.166",
    transform: "translate(-3336.294 904.848)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13579",
    d: "M3277.391 712.721a.66.66 0 0 1-.658-.614l-.588-8.527a.66.66 0 0 1 1.316-.091l.5 7.19.851-.754 1.341-4.972a.659.659 0 1 1 1.273.343l-1.392 5.163a.662.662 0 0 1-.2.322l-2 1.774a.659.659 0 0 1-.437.166",
    transform: "translate(-3261.164 939.11)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13580",
    d: "M3209.294 689.219a4.318 4.318 0 0 0-5.179 0 .659.659 0 0 1 0-1.319 2.974 2.974 0 0 0 2.122-.882.659.659 0 0 1 .935 0 2.976 2.976 0 0 0 2.123.882.659.659 0 1 1 0 1.319",
    transform: "translate(-3192.312 954.314)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13581",
    d: "M3304.562 709.921a3.21 3.21 0 0 1-2.857-1.739.659.659 0 1 1 1.172-.6 1.891 1.891 0 0 0 2.544.814.66.66 0 1 1 .6 1.172 3.189 3.189 0 0 1-1.464.356",
    transform: "translate(-3285.308 934.994)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13582",
    d: "M3372.143 732.765a5.733 5.733 0 0 1-5.41-3.841.659.659 0 0 1 1.246-.434 4.409 4.409 0 0 0 5.608 2.711.659.659 0 1 1 .434 1.245 5.7 5.7 0 0 1-1.877.319",
    transform: "translate(-3346.94 915.266)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13583",
    d: "M2906.065 827.545a.659.659 0 0 1-.659-.659V805.4a.659.659 0 1 1 1.319 0v21.484a.659.659 0 0 1-.659.659",
    transform: "translate(-2909.985 842.617)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13584",
    d: "M2805.9 898.035a.657.657 0 0 1-.466-.193l-5.594-5.595a.659.659 0 0 1 .933-.933l5.128 5.128 4.037-4.036a.659.659 0 1 1 .932.933l-4.5 4.5a.658.658 0 0 1-.466.193",
    transform: "translate(-2809.809 760.794)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13585",
    d: "M2850.968 865.489a.658.658 0 0 1-.466-.193l-3.085-3.085a.659.659 0 0 1 .933-.933l2.623 2.623 2.1-2.061a.659.659 0 0 1 .923.942l-2.569 2.518a.657.657 0 0 1-.461.188",
    transform: "translate(-2854.872 789.246)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13586",
    d: "M2881.83 826.236a.659.659 0 0 1-.467-.193l-1.363-1.366a.659.659 0 0 1 .932-.933l.9.9.9-.9a.659.659 0 0 1 .933.933l-1.366 1.366a.657.657 0 0 1-.466.193",
    transform: "translate(-2885.734 824.8)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13587",
    d: "M2707.5 732.13a.668.668 0 0 1-.078 0 6.509 6.509 0 0 1 2.843-12.7 5.336 5.336 0 0 1 7.558-2.168.659.659 0 0 1-.689 1.124 4.018 4.018 0 0 0-5.885 2.1.659.659 0 0 1-.9.378 2.716 2.716 0 0 0-1.166-.26 2.741 2.741 0 0 0-2.339 4.169.659.659 0 0 1-.246.923 2.741 2.741 0 0 0 .984 5.129.659.659 0 0 1-.077 1.314",
    transform: "translate(-2719.06 926.231)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13588",
    d: "M3047.1 929.007a.659.659 0 0 1-.077-1.314 2.739 2.739 0 0 0 2.414-2.721.659.659 0 0 1 1.319 0 4.058 4.058 0 0 1-3.578 4.031.682.682 0 0 1-.079 0",
    transform: "translate(-3043.576 729.355)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13589",
    d: "M2765.871 993.35a5.335 5.335 0 0 1-5.224-4.258.659.659 0 1 1 1.292-.266 4.016 4.016 0 0 0 6.558 2.229.659.659 0 1 1 .861 1 5.339 5.339 0 0 1-3.486 1.3",
    transform: "translate(-2772.85 668.743)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13590",
    d: "M2908.88 993.351a4.969 4.969 0 0 1-3.309-1.3.659.659 0 1 1 .861-1 3.565 3.565 0 0 0 2.97.94 4.02 4.02 0 0 0 3.4-3.169.66.66 0 0 1 1.292.266 5.341 5.341 0 0 1-4.512 4.21 5.23 5.23 0 0 1-.7.048",
    transform: "translate(-2909.925 668.742)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13591",
    d: "M3598.362 827.545a.659.659 0 0 1-.659-.659V805.4a.659.659 0 1 1 1.319 0v21.484a.659.659 0 0 1-.659.659",
    transform: "translate(-3565.76 842.617)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13592",
    d: "M3517.209 898.035a.658.658 0 0 1-.466-.193l-4.5-4.5a.66.66 0 0 1 .933-.933l4.037 4.036 5.128-5.128a.659.659 0 0 1 .933.933l-5.594 5.595a.658.658 0 0 1-.466.193",
    transform: "translate(-3484.623 760.794)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13593",
    d: "M3551.933 865.488a.656.656 0 0 1-.461-.188l-2.569-2.518a.659.659 0 1 1 .923-.942l2.1 2.061 2.623-2.623a.659.659 0 0 1 .932.933l-3.081 3.089a.658.658 0 0 1-.466.193",
    transform: "translate(-3519.346 789.247)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13594",
    d: "M3573.538 826.236a.658.658 0 0 1-.466-.193l-1.366-1.366a.659.659 0 0 1 .932-.933l.9.9.9-.9a.659.659 0 0 1 .933.933l-1.371 1.366a.657.657 0 0 1-.466.193",
    transform: "translate(-3540.951 824.8)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13595",
    d: "M3563.96 732.13a.659.659 0 0 1-.077-1.314 2.741 2.741 0 0 0 .984-5.129.66.66 0 0 1-.247-.923 2.741 2.741 0 0 0-3.505-3.909.659.659 0 0 1-.9-.378 4.017 4.017 0 0 0-5.885-2.1.659.659 0 1 1-.689-1.124 5.336 5.336 0 0 1 7.558 2.168 6.651 6.651 0 0 1 2.843 12.7.667.667 0 0 1-.078 0",
    transform: "translate(-3523.722 926.231)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13596",
    d: "M3403.537 929.007a.685.685 0 0 1-.078 0 4.058 4.058 0 0 1-3.578-4.031.659.659 0 1 1 1.319 0 2.739 2.739 0 0 0 2.414 2.721.659.659 0 0 1-.077 1.314",
    transform: "translate(-3378.374 729.355)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13597",
    d: "M3601.479 993.35a5.339 5.339 0 0 1-3.486-1.3.659.659 0 1 1 .861-1 4.016 4.016 0 0 0 6.558-2.229.659.659 0 1 1 1.292.266 5.334 5.334 0 0 1-5.224 4.258",
    transform: "translate(-3565.818 668.743)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13598",
    d: "M3461.892 993.35a5.22 5.22 0 0 1-.7-.048 5.341 5.341 0 0 1-4.512-4.21.659.659 0 1 1 1.292-.266 4.021 4.021 0 0 0 3.4 3.169 3.564 3.564 0 0 0 2.97-.94.659.659 0 1 1 .862 1 4.97 4.97 0 0 1-3.309 1.3",
    transform: "translate(-3432.165 668.743)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13599",
    d: "M201.107 1213.309H.659a.659.659 0 0 1 0-1.319h200.448a.659.659 0 0 1 0 1.319",
    transform: "translate(-157.852 456.853)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13601",
    d: "M5081.438 651.719h-17.251a.659.659 0 0 1-.66-.659 3.463 3.463 0 0 1 2.9-3.415 6.326 6.326 0 0 1 11.046-1.243 4.786 4.786 0 0 1 4.624 4.638.66.66 0 0 1-.659.679m-16.49-1.319h15.744a3.47 3.47 0 0 0-3.376-2.682h-.166a.662.662 0 0 1-.593-.314 5.007 5.007 0 0 0-9.026 1.056.66.66 0 0 1-.607.454 2.13 2.13 0 0 0-1.976 1.481",
    transform: "translate(-4946.396 967.874)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13815",
    d: "M5081.438 651.719h-17.251a.659.659 0 0 1-.66-.659 3.463 3.463 0 0 1 2.9-3.415 6.326 6.326 0 0 1 11.046-1.243 4.786 4.786 0 0 1 4.624 4.638.66.66 0 0 1-.659.679m-16.49-1.319h15.744a3.47 3.47 0 0 0-3.376-2.682h-.166a.662.662 0 0 1-.593-.314 5.007 5.007 0 0 0-9.026 1.056.66.66 0 0 1-.607.454 2.13 2.13 0 0 0-1.976 1.481",
    transform: "translate(-4691.531 978.23)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13602",
    d: "M7055.644 367.254h-17.251a.659.659 0 0 1-.66-.659 3.461 3.461 0 0 1 2.9-3.415 6.326 6.326 0 0 1 11.046-1.243 4.785 4.785 0 0 1 4.624 4.638.659.659 0 0 1-.659.679m-16.49-1.319h15.746a3.47 3.47 0 0 0-3.376-2.682h-.166a.662.662 0 0 1-.593-.314 5.007 5.007 0 0 0-9.026 1.056.66.66 0 0 1-.607.454 2.13 2.13 0 0 0-1.976 1.481",
    transform: "translate(-6824.314 1264.622)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13603",
    d: "M3982.155 339.47h-24.4a.659.659 0 0 1-.65-.771 3.619 3.619 0 0 1 2.99-2.95 6.625 6.625 0 0 1 10.018-2.9 14.04 14.04 0 0 0 7.43 1 5.3 5.3 0 0 1 5.274 4.919.659.659 0 0 1-.658.7m-23.471-1.319h22.7a3.973 3.973 0 0 0-4.952-2.83.659.659 0 0 1-.7-.23 3.969 3.969 0 0 0-5.308-.9.659.659 0 0 1-.784-.046 5.305 5.305 0 0 0-8.44 2.42.659.659 0 0 1-.607.454 2.3 2.3 0 0 0-1.9 1.127",
    transform: "translate(-3906.19 1290.8)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13604",
    d: "M5560.1 404.183h-24.4a.66.66 0 0 1-.65-.771 3.62 3.62 0 0 1 2.99-2.95 6.625 6.625 0 0 1 10.018-2.9 14.037 14.037 0 0 0 7.43 1 5.3 5.3 0 0 1 5.275 4.919.66.66 0 0 1-.658.7m-23.47-1.319h22.7a3.973 3.973 0 0 0-4.952-2.83.658.658 0 0 1-.7-.23 3.97 3.97 0 0 0-5.309-.9.66.66 0 0 1-.784-.046 5.3 5.3 0 0 0-8.44 2.421.659.659 0 0 1-.607.454 2.3 2.3 0 0 0-1.9 1.127",
    transform: "translate(-5400.887 1229.501)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13605",
    d: "M6377.521 449.651a.66.66 0 0 1-.66-.659v-35.3l-11.195-6.464-11.195 6.464v35.3a.66.66 0 0 1-1.319 0v-35.686a.66.66 0 0 1 .33-.571l11.854-6.844a.659.659 0 0 1 .659 0l11.854 6.844a.66.66 0 0 1 .33.571v35.686a.659.659 0 0 1-.659.659",
    transform: "translate(-6175.848 1220.511)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13606",
    d: "M6578.527 449.651a.66.66 0 0 1-.659-.659v-42.53a.659.659 0 1 1 1.319 0v42.53a.66.66 0 0 1-.66.659",
    transform: "translate(-6388.709 1220.511)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13607",
    d: "M6821.764 638.087a.659.659 0 0 1-.659-.659v-24.76l-11.2-6.464-5.989 3.445a.659.659 0 0 1-.658-1.143l6.318-3.635a.659.659 0 0 1 .658 0l11.855 6.844a.659.659 0 0 1 .33.571v25.141a.66.66 0 0 1-.66.659",
    transform: "translate(-6601.899 1032.027)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13608",
    d: "M6923.355 638.121a.66.66 0 0 1-.66-.659v-32.019a.659.659 0 1 1 1.319 0v32.018a.66.66 0 0 1-.659.659",
    transform: "translate(-6715.346 1032.026)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13609",
    d: "M6978.31 711.654a.654.654 0 0 1-.329-.089l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.959 4.018a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6760.809 935.85)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13610",
    d: "M6978.31 788.628a.654.654 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.959 4.018a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6760.809 862.937)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13611",
    d: "M6978.31 865.6a.654.654 0 0 1-.329-.089l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.959 4.018a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6760.809 790.024)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13612",
    d: "M6978.31 942.574a.654.654 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.959 4.018a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6760.809 717.112)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13613",
    d: "M6978.31 1019.548a.654.654 0 0 1-.329-.089l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.959 4.018a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6760.809 644.199)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13614",
    d: "M6978.31 1096.521a.654.654 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.959 4.018a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6760.809 571.287)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13615",
    d: "M7165.24 815.289a.66.66 0 0 1-.66-.659v-14.8l-11.2-6.464-5.988 3.445a.66.66 0 0 1-.658-1.143l6.318-3.635a.659.659 0 0 1 .658 0l11.854 6.844a.66.66 0 0 1 .33.571v15.176a.659.659 0 0 1-.659.659",
    transform: "translate(-6927.256 854.734)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13616",
    d: "M7266.831 815.289a.659.659 0 0 1-.659-.659v-22.02a.659.659 0 1 1 1.318 0v22.02a.659.659 0 0 1-.659.659",
    transform: "translate(-7040.702 854.734)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13617",
    d: "M7321.784 898.822a.657.657 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-7086.164 758.556)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13618",
    d: "M7321.784 975.8a.657.657 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-7086.164 685.643)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13619",
    d: "M7321.784 1052.768a.657.657 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.659.659 0 0 1-.331 1.23",
    transform: "translate(-7086.164 612.731)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13620",
    d: "M7321.784 1129.742a.657.657 0 0 1-.329-.089l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-7086.164 539.818)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13621",
    d: "M5653.123 815.289a.659.659 0 0 1-.659-.659v-15.177a.66.66 0 0 1 .329-.571l11.855-6.844a.659.659 0 0 1 .658 0l6.318 3.635a.659.659 0 0 1-.658 1.143l-5.988-3.445-11.2 6.464v14.8a.659.659 0 0 1-.659.659",
    transform: "translate(-5512.124 854.734)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13622",
    d: "M5877.839 815.289a.659.659 0 0 1-.66-.659v-22.02a.66.66 0 0 1 1.319 0v22.02a.66.66 0 0 1-.66.659",
    transform: "translate(-5724.985 854.734)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13623",
    d: "M5935.134 897a.66.66 0 0 1-.329-.088l-3.808-2.2a.659.659 0 1 1 .659-1.142l3.809 2.2a.659.659 0 0 1-.331 1.231",
    transform: "translate(-5775.65 758.556)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13624",
    d: "M5935.324 974.085A.657.657 0 0 1 5935 974l-4-2.309a.659.659 0 1 1 .659-1.142l4 2.309a.659.659 0 0 1-.33 1.231",
    transform: "translate(-5775.65 685.644)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13625",
    d: "M5935.017 1050.882a.654.654 0 0 1-.329-.089l-3.693-2.132a.659.659 0 0 1 .66-1.142l3.693 2.132a.66.66 0 0 1-.331 1.231",
    transform: "translate(-5775.649 612.731)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13626",
    d: "M5935.045 1127.871a.66.66 0 0 1-.329-.088l-3.719-2.148a.659.659 0 1 1 .659-1.142l3.72 2.147a.659.659 0 0 1-.331 1.231",
    transform: "translate(-5775.65 539.818)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13627",
    d: "M6285.485 709.788a.657.657 0 0 1-.33-.089l-3.729-2.152a.66.66 0 0 1 .66-1.142l3.729 2.153a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6107.595 935.85)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13628",
    d: "M6285.485 786.761a.657.657 0 0 1-.33-.089l-3.729-2.153a.66.66 0 0 1 .66-1.142l3.729 2.153a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6107.595 862.938)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13629",
    d: "M6285.485 863.735a.658.658 0 0 1-.33-.089l-3.729-2.153a.659.659 0 0 1 .66-1.142l3.729 2.153a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6107.595 790.024)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13630",
    d: "M6285.485 940.708a.658.658 0 0 1-.33-.089l-3.729-2.153a.659.659 0 0 1 .66-1.142l3.729 2.153a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6107.595 717.112)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13631",
    d: "M6285.485 1017.681a.658.658 0 0 1-.33-.088l-3.729-2.153a.659.659 0 0 1 .66-1.142l3.729 2.153a.659.659 0 0 1-.33 1.231",
    transform: "translate(-6107.595 644.2)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13632",
    d: "M6285.485 1094.655a.656.656 0 0 1-.33-.089l-3.729-2.152a.66.66 0 0 1 .66-1.142l3.729 2.153a.66.66 0 0 1-.33 1.231",
    transform: "translate(-6107.595 571.287)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13633",
    d: "M6637.011 512.387a.656.656 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-6437.516 1124.605)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13634",
    d: "M6637.011 589.36a.657.657 0 0 1-.329-.089l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-6437.516 1051.693)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13635",
    d: "M6637.011 666.334a.656.656 0 0 1-.329-.089l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-6437.516 978.779)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13636",
    d: "M6637.011 743.307a.656.656 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-6437.516 905.867)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13637",
    d: "M6637.011 820.28a.656.656 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-6437.516 832.954)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13638",
    d: "M6637.011 897.254a.656.656 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.659.659 0 0 1-.331 1.231",
    transform: "translate(-6437.516 760.041)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13639",
    d: "M6637.011 974.227a.657.657 0 0 1-.329-.088l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-6437.516 687.128)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13640",
    d: "M6637.011 1051.2a.657.657 0 0 1-.329-.089l-6.959-4.018a.659.659 0 1 1 .659-1.142l6.96 4.018a.66.66 0 0 1-.331 1.231",
    transform: "translate(-6437.516 614.216)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13641",
    d: "M6005.909 638.087a.659.659 0 0 1-.659-.659v-25.141a.66.66 0 0 1 .33-.571l11.855-6.844a.659.659 0 0 1 .658 0l6.318 3.635a.66.66 0 0 1-.658 1.143l-5.988-3.445-11.2 6.464v24.76a.66.66 0 0 1-.66.659",
    transform: "translate(-5846.299 1032.027)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13642",
    d: "M6230.624 638.121a.66.66 0 0 1-.659-.659v-32.019a.66.66 0 0 1 1.319 0v32.018a.66.66 0 0 1-.66.659",
    transform: "translate(-6059.159 1032.026)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13643",
    d: "M6430.575 603.208a.659.659 0 0 1-.659-.659v-33.924a.659.659 0 1 1 1.318 0v33.923a.659.659 0 0 1-.659.659",
    transform: "translate(-6248.562 1066.902)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13644",
    d: "M6509.011 555.015a.659.659 0 0 1-.66-.659v-36.608a.66.66 0 0 1 1.319 0v36.607a.66.66 0 0 1-.66.659",
    transform: "translate(-6322.86 1115.095)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13645",
    d: "M6430.575 604.188a.659.659 0 0 1-.659-.659v-33.924a.659.659 0 1 1 1.318 0v33.923a.659.659 0 0 1-.659.659",
    transform: "translate(-6248.562 1065.974)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13646",
    d: "M6509.011 556a.659.659 0 0 1-.66-.659v-36.613a.66.66 0 0 1 1.319 0v36.607a.66.66 0 0 1-.66.659",
    transform: "translate(-6322.86 1114.167)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13647",
    d: "M6080.126 795.341a.66.66 0 0 1-.66-.659V771.5a.66.66 0 0 1 1.319 0v23.184a.66.66 0 0 1-.66.659",
    transform: "translate(-5916.601 874.732)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13648",
    d: "M6158.561 747.147a.66.66 0 0 1-.659-.659V720.62a.659.659 0 1 1 1.318 0v25.868a.659.659 0 0 1-.659.659",
    transform: "translate(-5990.897 922.925)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13649",
    d: "M5728.117 974.145a.659.659 0 0 1-.659-.659v-13.142a.659.659 0 1 1 1.319 0v13.142a.66.66 0 0 1-.66.659",
    transform: "translate(-5583.162 695.848)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13650",
    d: "M5806.552 925.952a.659.659 0 0 1-.659-.659v-15.826a.659.659 0 1 1 1.319 0v15.826a.66.66 0 0 1-.66.659",
    transform: "translate(-5657.459 744.041)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13651",
    d: "M5592.795 1213.309h-42.383a.659.659 0 1 1 0-1.319h42.383a.659.659 0 0 1 0 1.319",
    transform: "translate(-5414.831 456.853)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13652",
    d: "M6844.9 1213.309h-41.66a.659.659 0 0 1 0-1.319h41.66a.659.659 0 0 1 0 1.319",
    transform: "translate(-6601.569 456.853)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13653",
    d: "M3869.827 813a7.534 7.534 0 0 1 0-15.067 7.466 7.466 0 0 1 5.466 2.349.659.659 0 1 1-.957.908 6.16 6.16 0 0 0-4.51-1.938 6.215 6.215 0 1 0 5.846 8.33.659.659 0 1 1 1.24.449 7.557 7.557 0 0 1-7.086 4.969",
    transform: "translate(-3816.393 849.065)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13654",
    d: "M3993.258 874.089a.659.659 0 0 1-.659-.659v-18.893a.659.659 0 0 1 1.319 0v18.892a.66.66 0 0 1-.66.659",
    transform: "translate(-3939.824 796.073)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13655",
    d: "M3922.54 931.475a.657.657 0 0 1-.466-.193l-3.96-3.959a.659.659 0 0 1 .933-.933l3.493 3.493 3.493-3.493a.659.659 0 0 1 .933.933l-3.96 3.959a.657.657 0 0 1-.466.193",
    transform: "translate(-3869.086 727.569)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13656",
    d: "M3962.153 881.093a.66.66 0 0 1-.466-.193l-1.753-1.753a.659.659 0 0 1 .933-.933l1.287 1.287 1.287-1.287a.659.659 0 0 1 .933.933l-1.753 1.753a.659.659 0 0 1-.466.193",
    transform: "translate(-3908.699 773.204)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13657",
    d: "M4427.417 813a7.557 7.557 0 0 1-7.086-4.969.659.659 0 0 1 1.24-.449 6.216 6.216 0 1 0 5.846-8.33 6.16 6.16 0 0 0-4.51 1.938.659.659 0 0 1-.957-.908 7.534 7.534 0 1 1 5.467 12.718",
    transform: "translate(-4344.954 849.065)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13658",
    d: "M4543.515 874.089a.66.66 0 0 1-.659-.659v-18.893a.659.659 0 0 1 1.319 0v18.892a.659.659 0 0 1-.66.659",
    transform: "translate(-4461.053 796.073)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13659",
    d: "M4472.041 931.475a.658.658 0 0 1-.466-.193l-3.959-3.959a.659.659 0 0 1 .933-.933l3.493 3.493 3.493-3.493a.659.659 0 0 1 .933.933l-3.959 3.959a.656.656 0 0 1-.466.193",
    transform: "translate(-4389.599 727.569)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13660",
    d: "M4511.653 881.093a.661.661 0 0 1-.467-.193l-1.753-1.753a.66.66 0 0 1 .933-.933l1.287 1.287 1.287-1.287a.66.66 0 0 1 .933.933l-1.753 1.753a.66.66 0 0 1-.466.193",
    transform: "translate(-4429.21 773.204)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13661",
    d: "M4095.128 708.09a10.288 10.288 0 1 1 10.289-10.288 10.3 10.3 0 0 1-10.289 10.288m0-19.258a8.97 8.97 0 1 0 8.97 8.97 8.98 8.98 0 0 0-8.97-8.97",
    transform: "translate(-4027.199 953.662)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13662",
    d: "M4268.026 769.492a.659.659 0 0 1-.659-.659v-24.718a.659.659 0 1 1 1.319 0v24.717a.66.66 0 0 1-.66.659",
    transform: "translate(-4200.097 900.67)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13663",
    d: "M4139.469 862.826a.66.66 0 0 1-.466-.193l-7.181-7.181a.659.659 0 0 1 .933-.933l6.714 6.714 6.714-6.714a.659.659 0 0 1 .933.933l-7.181 7.181a.658.658 0 0 1-.466.193",
    transform: "translate(-4071.52 795.649)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13664",
    d: "M4197.308 821.051a.66.66 0 0 1-.466-.193l-3.959-3.96a.659.659 0 0 1 .933-.933l3.493 3.493 3.493-3.493a.66.66 0 0 1 .933.933l-3.96 3.96a.659.659 0 0 1-.466.193",
    transform: "translate(-4129.359 832.168)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13665",
    d: "M4236.921 770.671a.659.659 0 0 1-.467-.193l-1.753-1.753a.66.66 0 0 1 .933-.933l1.287 1.287 1.287-1.287a.66.66 0 0 1 .933.933l-1.753 1.753a.658.658 0 0 1-.466.193",
    transform: "translate(-4168.971 877.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13666",
    d: "M3993.752 1213.309h-200.447a.659.659 0 1 1 0-1.319h200.447a.659.659 0 0 1 0 1.319",
    transform: "translate(-3750.419 456.853)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13667",
    d: "M7796.413 1213.309h-200.447a.659.659 0 0 1 0-1.319h200.447a.659.659 0 0 1 0 1.319",
    transform: "translate(-7352.474 456.853)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13669",
    d: "M10812.881 639.071h-8.766a.659.659 0 0 1-.659-.659v-1.665a.659.659 0 0 1 .659-.659h8.766a.659.659 0 0 1 .658.659v1.665a.659.659 0 0 1-.658.659m-8.106-1.319h7.446v-.346h-7.446z",
    transform: "translate(-10391.378 1002.375)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13670",
    d: "M10788.545 460.87h-11.635a.659.659 0 0 1-.66-.659v-9.832a.659.659 0 0 1 .66-.659h11.635a.66.66 0 0 1 .66.659v9.832a.66.66 0 0 1-.66.659m-10.976-1.319h10.317v-8.513h-10.317z",
    transform: "translate(-10365.608 1178.911)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13671",
    d: "M10749.321 716.678h-16.263a.659.659 0 0 1-.659-.659v-12.492a.659.659 0 0 1 .659-.659h16.263a.659.659 0 0 1 .659.659v12.492a.659.659 0 0 1-.659.659m-15.6-1.319h14.944v-11.172h-14.944z",
    transform: "translate(-10324.071 939.117)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13672",
    d: "M10749.32 670.827h-16.263a.659.659 0 0 1-.519-1.066l1.453-1.858a.661.661 0 0 1 .52-.253h13.354a.659.659 0 0 1 .519.253l1.454 1.858a.66.66 0 0 1-.519 1.066m-14.909-1.319h13.556l-.422-.539h-12.711z",
    transform: "translate(-10324.07 972.477)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13673",
    d: "M10737.545 704.187h-17.651a.659.659 0 0 1 0-1.319h17.651a.659.659 0 1 1 0 1.319",
    transform: "translate(-10311.6 939.117)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13674",
    d: "M10646.752 989.012h-28.361a.66.66 0 0 1-.659-.659v-12.492a.66.66 0 0 1 .659-.659h28.361a.66.66 0 0 1 .659.659v12.492a.66.66 0 0 1-.659.659m-27.7-1.319h27.041v-11.172h-27.041z",
    transform: "translate(-10215.452 681.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13675",
    d: "M10646.752 943.161h-28.361a.66.66 0 0 1-.52-1.066l1.455-1.858a.66.66 0 0 1 .52-.253h25.451a.66.66 0 0 1 .52.253l1.455 1.858a.66.66 0 0 1-.52 1.066m-27.007-1.319h25.653l-.423-.539h-24.81z",
    transform: "translate(-10215.452 714.51)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13676",
    d: "M10634.977 976.521h-29.75a.659.659 0 0 1 0-1.319h29.75a.659.659 0 0 1 0 1.319",
    transform: "translate(-10202.983 681.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13677",
    d: "M10646.752 943.161h-28.361a.66.66 0 0 1-.52-1.066l1.455-1.858a.66.66 0 0 1 .52-.253h25.451a.66.66 0 0 1 .52.253l1.455 1.858a.66.66 0 0 1-.52 1.066m-27.007-1.319h25.653l-.423-.539h-24.81z",
    transform: "translate(-10215.452 714.51)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13678",
    d: "M10634.977 976.521h-29.75a.659.659 0 0 1 0-1.319h29.75a.659.659 0 0 1 0 1.319",
    transform: "translate(-10202.983 681.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13679",
    d: "M10776.144 637.406h-13.1a.659.659 0 1 1 0-1.319h13.1a.659.659 0 0 1 0 1.319",
    transform: "translate(-10352.474 1002.375)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13680",
    d: "M10776.144 451.038h-13.1a.659.659 0 1 1 0-1.319h13.1a.659.659 0 0 1 0 1.319",
    transform: "translate(-10352.474 1178.911)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13681",
    d: "M10828.855 489.135a3.908 3.908 0 1 1 3.908-3.908 3.912 3.912 0 0 1-3.908 3.908m0-6.5a2.589 2.589 0 1 0 2.589 2.589 2.593 2.593 0 0 0-2.589-2.589",
    transform: "translate(-10411.737 1148.978)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13682",
    d: "M10889.047 501.109h-1.856a.659.659 0 0 1-.659-.659v-2.523a.659.659 0 1 1 1.318 0v1.864h1.2a.659.659 0 1 1 0 1.319",
    transform: "translate(-10470.072 1133.871)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13689",
    d: "M10776.491 748.981a.659.659 0 0 1-.659-.659v-2.459a.659.659 0 1 1 1.318 0v2.459a.659.659 0 0 1-.659.659",
    transform: "translate(-10365.212 899.015)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13690",
    d: "M10813.391 748.981a.659.659 0 0 1-.659-.659v-2.459a.66.66 0 0 1 1.319 0v2.459a.66.66 0 0 1-.66.659",
    transform: "translate(-10400.165 899.015)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13691",
    d: "M10850.291 748.981a.66.66 0 0 1-.66-.659v-2.459a.66.66 0 0 1 1.319 0v2.459a.659.659 0 0 1-.659.659",
    transform: "translate(-10435.118 899.015)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13692",
    d: "M10887.19 748.981a.659.659 0 0 1-.659-.659v-2.459a.659.659 0 1 1 1.318 0v2.459a.659.659 0 0 1-.659.659",
    transform: "translate(-10470.072 899.015)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13693",
    d: "M10924.092 748.981a.659.659 0 0 1-.66-.659v-2.459a.659.659 0 1 1 1.318 0v2.459a.659.659 0 0 1-.658.659",
    transform: "translate(-10505.026 899.015)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13694",
    d: "M10960.99 748.981a.659.659 0 0 1-.66-.659v-2.459a.66.66 0 0 1 1.319 0v2.459a.66.66 0 0 1-.659.659",
    transform: "translate(-10539.977 899.015)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13695",
    d: "M10997.891 748.981a.659.659 0 0 1-.66-.659v-2.459a.66.66 0 0 1 1.319 0v2.459a.659.659 0 0 1-.659.659",
    transform: "translate(-10574.931 899.015)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13696",
    d: "M10673.182 1030.387h-5.738a.659.659 0 0 1-.658-.659v-7.319a3.528 3.528 0 0 1 7.057 0v7.319a.66.66 0 0 1-.66.659m-5.078-1.319h4.419v-6.659a2.209 2.209 0 0 0-4.419 0z",
    transform: "translate(-10261.918 639.775)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13697",
    d: "M10838.547 1030.387h-5.737a.659.659 0 0 1-.659-.659v-7.319a3.528 3.528 0 0 1 7.057 0v7.319a.659.659 0 0 1-.66.659m-5.078-1.319h4.42v-6.659a2.21 2.21 0 0 0-4.42 0z",
    transform: "translate(-10418.56 639.775)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13698",
    d: "M11003.911 1030.387h-5.737a.659.659 0 0 1-.66-.659v-7.319a3.528 3.528 0 0 1 7.057 0v7.319a.659.659 0 0 1-.659.659m-5.078-1.319h4.419v-6.659a2.209 2.209 0 0 0-4.419 0z",
    transform: "translate(-10575.199 639.775)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13732",
    d: "M10319.048 887.442a.659.659 0 0 1-.659-.659v-18.149a.659.659 0 1 1 1.318 0v18.148a.659.659 0 0 1-.659.659",
    transform: "translate(-9931.901 782.72)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13733",
    d: "M10271.033 761.748a.656.656 0 0 1-.244-.047 5.458 5.458 0 0 1-1.545-1.024 4.739 4.739 0 0 1-1.545-3.533c0-3.063 2.689-6.723 2.8-6.878a.66.66 0 0 1 1.06 0c.114.154 2.8 3.815 2.8 6.878a4.736 4.736 0 0 1-1.546 3.533 5.464 5.464 0 0 1-1.543 1.024.668.668 0 0 1-.244.047m0-9.911c-.225.352-.5.8-.764 1.311a9.158 9.158 0 0 0-1.252 4 2.238 2.238 0 1 0 4.029 0 9.177 9.177 0 0 0-1.26-4.014c-.267-.5-.533-.947-.754-1.294",
    transform: "translate(-9883.886 894.471)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13734",
    d: "M10368.883 886.595a.659.659 0 0 1-.652-.564 9.063 9.063 0 0 1 .424-4.013 8.639 8.639 0 0 1 5.744-5.069.66.66 0 0 1 .784.838 13.44 13.44 0 0 0-.491 2.572c-.02.241-.023.485-.029.743a3.989 3.989 0 0 1-1.192 3.314 13.073 13.073 0 0 1-4.416 2.156.652.652 0 0 1-.171.023m4.729-7.955a8.391 8.391 0 0 0-.873.468 6.641 6.641 0 0 0-2.848 3.37 7.294 7.294 0 0 0-.405 2.575 10.284 10.284 0 0 0 3.121-1.634c.667-.576.714-1.266.737-2.344 0-.266.011-.54.033-.818a13.423 13.423 0 0 1 .234-1.617",
    transform: "translate(-9979.052 774.236)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13735",
    d: "M10320.686 979.349a.66.66 0 0 1-.635-.836c.938-3.38 5.361-8.441 5.549-8.655a.66.66 0 0 1 .992.87 47.263 47.263 0 0 0-2.335 2.934 18.509 18.509 0 0 0-2.937 5.2.658.658 0 0 1-.635.483",
    transform: "translate(-9933.453 686.425)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13736",
    d: "M10166.373 886.6a.659.659 0 0 1-.172-.023 13.082 13.082 0 0 1-4.415-2.156 3.983 3.983 0 0 1-1.192-3.314c-.006-.259-.011-.5-.029-.743a13.369 13.369 0 0 0-.492-2.572.66.66 0 0 1 .783-.838 8.637 8.637 0 0 1 5.746 5.069 9.063 9.063 0 0 1 .424 4.012.661.661 0 0 1-.652.564m-4.729-7.956a13.23 13.23 0 0 1 .235 1.617c.021.278.027.553.033.818.022 1.078.07 1.767.736 2.344a10.313 10.313 0 0 0 3.12 1.634 7.349 7.349 0 0 0-.4-2.574 7.015 7.015 0 0 0-3.722-3.839",
    transform: "translate(-9781.909 774.236)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13737",
    d: "M10220.262 979.349a.66.66 0 0 1-.636-.483 18.509 18.509 0 0 0-2.942-5.212 47.38 47.38 0 0 0-2.328-2.926.66.66 0 0 1 .991-.87c.187.214 4.612 5.276 5.551 8.655a.661.661 0 0 1-.636.836",
    transform: "translate(-9833.201 686.425)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13738",
    d: "M9927.17 737.128a.66.66 0 0 1-.66-.659v-26.52a.66.66 0 0 1 1.319 0v26.52a.659.659 0 0 1-.659.659",
    transform: "translate(-9560.696 933.034)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13739",
    d: "M9879.154 603.062a.657.657 0 0 1-.244-.047 5.448 5.448 0 0 1-1.544-1.024 4.74 4.74 0 0 1-1.546-3.533c0-3.063 2.689-6.723 2.8-6.878a.659.659 0 0 1 1.059 0c.114.154 2.8 3.815 2.8 6.878a4.736 4.736 0 0 1-1.546 3.533 5.45 5.45 0 0 1-1.543 1.024.665.665 0 0 1-.244.047m0-9.911c-.225.352-.494.8-.764 1.311a9.157 9.157 0 0 0-1.252 4 2.238 2.238 0 1 0 4.029 0 9.177 9.177 0 0 0-1.26-4.013c-.267-.5-.533-.947-.754-1.294",
    transform: "translate(-9512.68 1044.786)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13740",
    d: "M9977 727.909a.659.659 0 0 1-.652-.564 9.03 9.03 0 0 1 .424-4.012 8.638 8.638 0 0 1 5.745-5.069.66.66 0 0 1 .783.838 13.486 13.486 0 0 0-.492 2.572c-.019.24-.023.485-.028.743a3.989 3.989 0 0 1-1.192 3.314 13.085 13.085 0 0 1-4.416 2.156.66.66 0 0 1-.171.023m4.729-7.955a8.292 8.292 0 0 0-.873.468 6.641 6.641 0 0 0-2.848 3.37 7.293 7.293 0 0 0-.405 2.575 10.3 10.3 0 0 0 3.121-1.634c.666-.577.715-1.266.736-2.344.006-.266.012-.54.033-.818a13.222 13.222 0 0 1 .235-1.616",
    transform: "translate(-9607.848 924.551)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13741",
    d: "M9928.809 820.662a.66.66 0 0 1-.637-.836c.939-3.38 5.363-8.441 5.551-8.655a.659.659 0 0 1 .99.87c-.011.013-1.126 1.286-2.334 2.934a18.475 18.475 0 0 0-2.936 5.2.661.661 0 0 1-.635.483",
    transform: "translate(-9562.247 836.74)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13742",
    d: "M9774.493 727.91a.655.655 0 0 1-.171-.023 13.09 13.09 0 0 1-4.416-2.156 3.988 3.988 0 0 1-1.191-3.314c-.006-.259-.011-.5-.029-.743a13.453 13.453 0 0 0-.492-2.572.66.66 0 0 1 .783-.838 8.639 8.639 0 0 1 5.746 5.069 9.015 9.015 0 0 1 .422 4.012.657.657 0 0 1-.651.564m-4.729-7.955a13.029 13.029 0 0 1 .236 1.617c.021.278.027.553.033.818.021 1.078.07 1.767.736 2.344a10.3 10.3 0 0 0 3.119 1.634 7.368 7.368 0 0 0-.4-2.574 6.646 6.646 0 0 0-2.848-3.37 8.31 8.31 0 0 0-.875-.468",
    transform: "translate(-9410.704 924.55)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13743",
    d: "M9828.383 820.662a.659.659 0 0 1-.635-.483 18.492 18.492 0 0 0-2.943-5.212 47.024 47.024 0 0 0-2.327-2.925.66.66 0 1 1 .991-.87c.188.214 4.611 5.276 5.55 8.655a.66.66 0 0 1-.636.836",
    transform: "translate(-9461.996 836.74)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13744",
    d: "M9977 919.97a.659.659 0 0 1-.652-.564 9.03 9.03 0 0 1 .424-4.012 8.638 8.638 0 0 1 5.745-5.069.66.66 0 0 1 .783.838 13.488 13.488 0 0 0-.492 2.572c-.019.241-.023.485-.028.743a3.989 3.989 0 0 1-1.192 3.314 13.081 13.081 0 0 1-4.416 2.156.657.657 0 0 1-.171.023m4.729-7.955a8.3 8.3 0 0 0-.873.468 6.642 6.642 0 0 0-2.848 3.37 7.375 7.375 0 0 0-.4 2.574 10.3 10.3 0 0 0 3.12-1.634c.666-.576.715-1.266.736-2.344.006-.266.012-.54.033-.818a13.224 13.224 0 0 1 .235-1.617",
    transform: "translate(-9607.848 742.622)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13745",
    d: "M9928.809 1012.724a.66.66 0 0 1-.637-.836c.939-3.38 5.363-8.441 5.551-8.655a.659.659 0 0 1 .99.87c-.011.013-1.126 1.285-2.334 2.934a18.475 18.475 0 0 0-2.936 5.2.661.661 0 0 1-.635.483",
    transform: "translate(-9562.247 654.81)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13746",
    d: "M9774.493 919.97a.657.657 0 0 1-.171-.023 13.08 13.08 0 0 1-4.415-2.156 3.986 3.986 0 0 1-1.192-3.314c-.006-.259-.011-.5-.029-.743a13.456 13.456 0 0 0-.492-2.572.66.66 0 0 1 .783-.838 8.639 8.639 0 0 1 5.746 5.069 9.015 9.015 0 0 1 .422 4.012.657.657 0 0 1-.651.564m-4.729-7.955a13.028 13.028 0 0 1 .236 1.617c.021.278.027.553.033.818.021 1.078.07 1.767.736 2.344a10.273 10.273 0 0 0 3.119 1.634 7.372 7.372 0 0 0-.4-2.575 6.647 6.647 0 0 0-2.848-3.37 8.32 8.32 0 0 0-.875-.468",
    transform: "translate(-9410.704 742.622)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13747",
    d: "M9828.383 1012.724a.659.659 0 0 1-.635-.483 18.491 18.491 0 0 0-2.943-5.212 47.607 47.607 0 0 0-2.327-2.926.66.66 0 1 1 .991-.87c.188.214 4.611 5.276 5.55 8.655a.66.66 0 0 1-.636.836",
    transform: "translate(-9461.996 654.81)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13748",
    d: "M10100.1 1024.4a.666.666 0 0 1-.154-.018 3.336 3.336 0 0 1-2.531-3.217c-.014-2.275 2.014-5.258 2.1-5.384a.66.66 0 0 1 .54-.287.66.66 0 0 1 .539.281c.088.125 2.146 3.085 2.16 5.36a3.336 3.336 0 0 1-2.5 3.245.658.658 0 0 1-.162.02m-.035-7a8.941 8.941 0 0 0-1.332 3.761 1.868 1.868 0 0 0 .756 1.554 2.536 2.536 0 0 0 .607.335 2.506 2.506 0 0 0 .636-.368 1.864 1.864 0 0 0 .707-1.536 8.941 8.941 0 0 0-1.374-3.747",
    transform: "translate(-9722.581 642.979)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13749",
    d: "M10134.95 1126.625a.658.658 0 0 1-.658-.661l.01-4.828a.66.66 0 0 1 .66-.658.659.659 0 0 1 .658.661l-.011 4.828a.66.66 0 0 1-.659.658",
    transform: "translate(-9757.515 543.537)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13750",
    d: "M8764 657.137a.66.66 0 0 1-.659-.659V625.5a.659.659 0 1 1 1.318 0v30.974a.659.659 0 0 1-.659.659",
    transform: "translate(-8458.891 1013.025)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13751",
    d: "M8647 758.767a.658.658 0 0 1-.467-.193l-6.492-6.491a.66.66 0 0 1 .933-.933l6.026 6.025 7.6-7.6a.659.659 0 1 1 .933.932l-8.066 8.066a.658.658 0 0 1-.466.193",
    transform: "translate(-8341.912 895.056)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13752",
    d: "M8697.064 711.843a.656.656 0 0 1-.461-.188l-3.705-3.63a.66.66 0 1 1 .924-.942l3.237 3.173 3.986-3.986a.659.659 0 0 1 .933.933l-4.448 4.448a.654.654 0 0 1-.466.193",
    transform: "translate(-8391.976 936.077)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13753",
    d: "M8728.215 655.253a.657.657 0 0 1-.467-.193l-1.97-1.969a.659.659 0 0 1 .933-.933l1.5 1.5 1.5-1.5a.659.659 0 0 1 .933.933l-1.97 1.969a.658.658 0 0 1-.466.193",
    transform: "translate(-8423.124 987.335)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13754",
    d: "M8714.406 519.574a.659.659 0 0 1-.077-1.314 4.243 4.243 0 0 0 1.524-7.939.658.658 0 0 1-.247-.923 4.244 4.244 0 0 0-5.427-6.052.659.659 0 0 1-.9-.378 6.084 6.084 0 0 0-8.912-3.176.659.659 0 1 1-.689-1.124 7.4 7.4 0 0 1 10.589 3.228 5.564 5.564 0 0 1 6.774 7.614 5.562 5.562 0 0 1-2.555 10.06.67.67 0 0 1-.078 0",
    transform: "translate(-8398.285 1133.575)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13755",
    d: "M8768.5 896.189a7.41 7.41 0 0 1-4.837-1.8.66.66 0 0 1 .862-1 6.081 6.081 0 0 0 9.93-3.376.659.659 0 1 1 1.291.266 7.4 7.4 0 0 1-7.246 5.906",
    transform: "translate(-8458.976 762.34)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13756",
    d: "M8482.755 519.574a.674.674 0 0 1-.079 0 5.561 5.561 0 0 1-2.554-10.06 5.564 5.564 0 0 1 6.773-7.614 7.4 7.4 0 0 1 10.589-3.228.659.659 0 1 1-.689 1.124 6.083 6.083 0 0 0-8.911 3.176.66.66 0 0 1-.9.378 4.243 4.243 0 0 0-5.426 6.052.66.66 0 0 1-.247.923 4.243 4.243 0 0 0 1.524 7.939.659.659 0 0 1-.077 1.314",
    transform: "translate(-8188.388 1133.575)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13757",
    d: "M8566.905 896.188a7.4 7.4 0 0 1-7.246-5.906.659.659 0 1 1 1.291-.266 6.081 6.081 0 0 0 9.93 3.376.66.66 0 0 1 .862 1 7.413 7.413 0 0 1-4.837 1.8",
    transform: "translate(-8265.939 762.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13758",
    d: "M8730.982 364.683a.659.659 0 0 1-.658-.659v-.548h-.549a.659.659 0 0 1 0-1.319h.549v-.548a.659.659 0 1 1 1.318 0v.548h.548a.659.659 0 0 1 0 1.319h-.548v.548a.659.659 0 0 1-.66.659",
    transform: "translate(-8426.469 1262.998)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13762",
    d: "M8549.854 339.9a6.521 6.521 0 1 1 .653-.571.661.661 0 0 1-.653.571",
    transform: "translate(-8255.505 1285.26)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13763",
    d: "M9198.48 277.932a6.4 6.4 0 1 1 .654-.571.659.659 0 0 1-.654.571",
    transform: "translate(-8869.913 1343.956)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13764",
    d: "M8313.551 207.7a.66.66 0 0 1-.66-.659v-.548h-.548a.659.659 0 0 1 0-1.319h.548v-.548a.66.66 0 0 1 1.319 0v.548h.548a.659.659 0 1 1 0 1.319h-.548v.548a.66.66 0 0 1-.659.659",
    transform: "translate(-8031.058 1411.699)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13769",
    d: "M9250.9 460.587h-12.179a.659.659 0 0 1 0-1.319h12.179a.659.659 0 0 1 0 1.319",
    transform: "translate(-8922.996 1166.845)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13770",
    d: "M9280.86 511.2h-6.96a.659.659 0 0 1 0-1.319h6.959a.659.659 0 1 1 0 1.319",
    transform: "translate(-8956.316 1118.904)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13771",
    d: "M9378.628 409.975h-3.6a.659.659 0 0 1 0-1.319h3.6a.659.659 0 0 1 0 1.319",
    transform: "translate(-9037.686 1217.808)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13772",
    d: "M9286.748 409.975h-1.855a.659.659 0 0 1 0-1.319h1.855a.659.659 0 1 1 0 1.319",
    transform: "translate(-8966.727 1214.787)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13773",
    d: "M8469.941 163.956h-6.671a.659.659 0 0 1 0-1.319h6.671a.659.659 0 0 1 0 1.319",
    transform: "translate(-8174.024 1450.848)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13774",
    d: "M8545.023 195.071h-4.785a.659.659 0 0 1 0-1.319h4.785a.659.659 0 0 1 0 1.319",
    transform: "translate(-8246.931 1421.375)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13776",
    d: "M8503.79 163.957H8499a.659.659 0 0 1 0-1.319h4.785a.659.659 0 1 1 0 1.319",
    transform: "translate(-8207.873 1450.847)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13778",
    d: "M9477.028 640.5a.659.659 0 0 1-.659-.659v-.183h-.184a.659.659 0 0 1 0-1.319h.184v-.183a.659.659 0 1 1 1.318 0v.183h.184a.659.659 0 0 1 0 1.319h-.184v.183a.659.659 0 0 1-.659.659",
    transform: "translate(-9133.503 1001.037)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13731",
    d: "M8059.1 1065.323h-5.582a.66.66 0 0 1-.659-.659v-8.242a.66.66 0 0 1 .659-.659h5.582a.659.659 0 0 1 .659.659v8.242a.659.659 0 0 1-.659.659m-4.922-1.319h4.263v-6.923h-4.263z",
    transform: "translate(-7717.134 604.839)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13730",
    d: "M8106.479 236.667a.66.66 0 0 1-.646-.526l-2.188-10.586a.659.659 0 1 1 1.291-.267l2.189 10.585a.66.66 0 0 1-.646.793",
    transform: "translate(-7765.23 1392)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13729",
    d: "M8063.385 236.667a.66.66 0 0 1-.646-.793l2.189-10.585a.659.659 0 1 1 1.292.267l-2.189 10.586a.66.66 0 0 1-.645.526",
    transform: "translate(-7726.481 1392)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13727",
    d: "M8343.936 886.7a.66.66 0 0 1-.659-.659v-2.989a.66.66 0 0 1 1.319 0v2.989a.66.66 0 0 1-.66.659",
    transform: "translate(-7992.233 769.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13726",
    d: "M8300.48 886.7a.66.66 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.318 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-7951.07 769.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13725",
    d: "M8343.936 785.06a.66.66 0 0 1-.659-.659v-2.99a.66.66 0 0 1 1.319 0v2.99a.66.66 0 0 1-.66.659",
    transform: "translate(-7992.233 865.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13724",
    d: "M8300.48 785.06a.66.66 0 0 1-.659-.659v-2.99a.659.659 0 1 1 1.318 0v2.99a.659.659 0 0 1-.659.659",
    transform: "translate(-7951.07 865.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13723",
    d: "M7908.165 886.7a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.319 0v2.989a.66.66 0 0 1-.66.659",
    transform: "translate(-7579.451 769.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13722",
    d: "M7864.711 886.7a.66.66 0 0 1-.66-.659v-2.989a.66.66 0 0 1 1.319 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-7538.289 769.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13721",
    d: "M7908.165 785.06a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 0 1 1.319 0v2.99a.66.66 0 0 1-.66.659",
    transform: "translate(-7579.451 865.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13720",
    d: "M7864.711 785.06a.66.66 0 0 1-.66-.659v-2.99a.66.66 0 0 1 1.319 0v2.99a.66.66 0 0 1-.659.659",
    transform: "translate(-7538.289 865.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13719",
    d: "M8212.96 901.692a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.318 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-7868.167 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13718",
    d: "M8169.5 901.692a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.318 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-7827.004 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13717",
    d: "M8126.051 901.692a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.319 0v2.989a.66.66 0 0 1-.66.659",
    transform: "translate(-7785.842 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13716",
    d: "M8082.6 901.692a.66.66 0 0 1-.659-.659v-2.989a.66.66 0 0 1 1.319 0v2.989a.66.66 0 0 1-.66.659",
    transform: "translate(-7744.68 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13715",
    d: "M8039.141 901.692a.66.66 0 0 1-.66-.659v-2.989a.659.659 0 1 1 1.319 0v2.989a.66.66 0 0 1-.659.659",
    transform: "translate(-7703.517 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13714",
    d: "M7995.687 901.692a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.318 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-7662.355 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13713",
    d: "M8212.96 807.524a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 1 1 1.318 0v2.99a.659.659 0 0 1-.659.659",
    transform: "translate(-7868.167 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13712",
    d: "M8169.5 807.524a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 1 1 1.318 0v2.99a.659.659 0 0 1-.659.659",
    transform: "translate(-7827.004 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13711",
    d: "M8126.051 807.524a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 0 1 1.319 0v2.99a.66.66 0 0 1-.66.659",
    transform: "translate(-7785.842 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13710",
    d: "M8082.6 807.524a.66.66 0 0 1-.659-.659v-2.99a.66.66 0 0 1 1.319 0v2.99a.66.66 0 0 1-.66.659",
    transform: "translate(-7744.68 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13709",
    d: "M8039.141 807.524a.66.66 0 0 1-.66-.659v-2.99a.659.659 0 0 1 1.319 0v2.99a.66.66 0 0 1-.659.659",
    transform: "translate(-7703.517 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13708",
    d: "M7995.687 807.524a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 1 1 1.318 0v2.99a.659.659 0 0 1-.659.659",
    transform: "translate(-7662.355 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13707",
    d: "M8165.647 680.668h-2.635a.659.659 0 0 1-.659-.659v-5.019a.659.659 0 0 1 .659-.659h2.635a.659.659 0 0 1 .659.659v5.019a.659.659 0 0 1-.659.659m-1.976-1.319h1.316v-3.7h-1.316z",
    transform: "translate(-7820.853 966.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13706",
    d: "M8081.984 481.074h-2.635a.659.659 0 0 1-.659-.659V475.4a.659.659 0 0 1 .659-.659h2.635a.659.659 0 0 1 .659.659v5.019a.659.659 0 0 1-.659.659m-1.976-1.319h1.316v-3.7h-1.316z",
    transform: "translate(-7741.605 1155.214)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13705",
    d: "M8081.984 680.668h-2.635a.659.659 0 0 1-.659-.659v-5.019a.659.659 0 0 1 .659-.659h2.635a.659.659 0 0 1 .659.659v5.019a.659.659 0 0 1-.659.659m-1.976-1.319h1.316v-3.7h-1.316z",
    transform: "translate(-7741.605 966.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13704",
    d: "M7998.321 680.668h-2.635a.659.659 0 0 1-.659-.659v-5.019a.659.659 0 0 1 .659-.659h2.635a.659.659 0 0 1 .659.659v5.019a.659.659 0 0 1-.659.659m-1.976-1.319h1.316v-3.7h-1.316z",
    transform: "translate(-7662.355 966.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13703",
    d: "M8264.936 748.3h-6.755a.659.659 0 0 1-.659-.659v-25.9a.659.659 0 0 1 .659-.659h6.755a.659.659 0 0 1 .66.659v25.9a.659.659 0 0 1-.66.659m-6.1-1.319h5.437v-24.574h-5.437z",
    transform: "translate(-7911.002 921.858)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13702",
    d: "M7829.165 748.3h-6.756a.659.659 0 0 1-.659-.659v-25.9a.659.659 0 0 1 .659-.659h6.756a.659.659 0 0 1 .659.659v25.9a.659.659 0 0 1-.659.659m-6.1-1.319h5.437v-24.574h-5.437z",
    transform: "translate(-7498.22 921.858)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13701",
    d: "M8024.819 234.235h-9.377a.659.659 0 0 1-.6-.924l4.688-10.721a.66.66 0 0 1 1.208 0l4.689 10.721a.66.66 0 0 1-.6.924m-8.369-1.319h7.361l-3.681-8.416z",
    transform: "translate(-7681.069 1394.432)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13700",
    d: "M8024.819 436.963h-9.377a.66.66 0 0 1-.66-.659v-10.223a.66.66 0 0 1 .66-.659h9.377a.66.66 0 0 1 .66.659V436.3a.66.66 0 0 1-.66.659m-8.718-1.319h8.059v-8.9h-8.06z",
    transform: "translate(-7681.067 1201.926)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13699",
    d: "M7966.7 651.784h-16.233a.659.659 0 0 1-.659-.659v-31.274a.659.659 0 0 1 .659-.659h16.233a.659.659 0 0 1 .659.659v31.273a.659.659 0 0 1-.659.659m-15.574-1.319h14.915v-29.953h-14.915z",
    transform: "translate(-7619.522 1018.378)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13782",
    d: "M7966.7 651.784h-16.233a.659.659 0 0 1-.659-.659v-31.274a.659.659 0 0 1 .659-.659h16.233a.659.659 0 0 1 .659.659v31.273a.659.659 0 0 1-.659.659m-15.574-1.319h14.915v-29.953h-14.915z",
    transform: "translate(-7846.524 1018.378)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13783",
    d: "M8024.819 436.963h-9.377a.66.66 0 0 1-.66-.659v-10.223a.66.66 0 0 1 .66-.659h9.377a.66.66 0 0 1 .66.659V436.3a.66.66 0 0 1-.66.659m-8.718-1.319h8.059v-8.9h-8.06z",
    transform: "translate(-7908.069 1201.926)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13784",
    d: "M8024.819 234.235h-9.377a.659.659 0 0 1-.6-.924l4.688-10.721a.66.66 0 0 1 1.208 0l4.689 10.721a.66.66 0 0 1-.6.924m-8.369-1.319h7.361l-3.681-8.416z",
    transform: "translate(-7908.071 1394.432)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13785",
    d: "M7829.165 748.3h-6.756a.659.659 0 0 1-.659-.659v-25.9a.659.659 0 0 1 .659-.659h6.756a.659.659 0 0 1 .659.659v25.9a.659.659 0 0 1-.659.659m-6.1-1.319h5.437v-24.574h-5.437z",
    transform: "translate(-7725.221 921.858)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13786",
    d: "M8264.936 748.3h-6.755a.659.659 0 0 1-.659-.659v-25.9a.659.659 0 0 1 .659-.659h6.755a.659.659 0 0 1 .66.659v25.9a.659.659 0 0 1-.66.659m-6.1-1.319h5.437v-24.574h-5.437z",
    transform: "translate(-8138.003 921.858)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13787",
    d: "M7998.321 680.668h-2.635a.659.659 0 0 1-.659-.659v-5.019a.659.659 0 0 1 .659-.659h2.635a.659.659 0 0 1 .659.659v5.019a.659.659 0 0 1-.659.659m-1.976-1.319h1.316v-3.7h-1.316z",
    transform: "translate(-7889.357 966.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13788",
    d: "M8081.984 680.668h-2.635a.659.659 0 0 1-.659-.659v-5.019a.659.659 0 0 1 .659-.659h2.635a.659.659 0 0 1 .659.659v5.019a.659.659 0 0 1-.659.659m-1.976-1.319h1.316v-3.7h-1.316z",
    transform: "translate(-7968.607 966.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13789",
    d: "M8081.984 481.074h-2.635a.659.659 0 0 1-.659-.659V475.4a.659.659 0 0 1 .659-.659h2.635a.659.659 0 0 1 .659.659v5.019a.659.659 0 0 1-.659.659m-1.976-1.319h1.316v-3.7h-1.316z",
    transform: "translate(-7968.607 1155.214)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13790",
    d: "M8165.647 680.668h-2.635a.659.659 0 0 1-.659-.659v-5.019a.659.659 0 0 1 .659-.659h2.635a.659.659 0 0 1 .659.659v5.019a.659.659 0 0 1-.659.659m-1.976-1.319h1.316v-3.7h-1.316z",
    transform: "translate(-8047.855 966.149)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13791",
    d: "M7995.687 807.524a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 1 1 1.318 0v2.99a.659.659 0 0 1-.659.659",
    transform: "translate(-7889.357 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13792",
    d: "M8039.141 807.524a.66.66 0 0 1-.66-.659v-2.99a.659.659 0 0 1 1.319 0v2.99a.66.66 0 0 1-.659.659",
    transform: "translate(-7930.519 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13793",
    d: "M8082.6 807.524a.66.66 0 0 1-.659-.659v-2.99a.66.66 0 0 1 1.319 0v2.99a.66.66 0 0 1-.66.659",
    transform: "translate(-7971.682 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13794",
    d: "M8126.051 807.524a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 0 1 1.319 0v2.99a.66.66 0 0 1-.66.659",
    transform: "translate(-8012.844 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13795",
    d: "M8169.5 807.524a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 1 1 1.318 0v2.99a.659.659 0 0 1-.659.659",
    transform: "translate(-8054.006 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13796",
    d: "M8212.96 807.524a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 1 1 1.318 0v2.99a.659.659 0 0 1-.659.659",
    transform: "translate(-8095.169 844.063)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13797",
    d: "M7995.687 901.692a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.318 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-7889.357 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13798",
    d: "M8039.141 901.692a.66.66 0 0 1-.66-.659v-2.989a.659.659 0 1 1 1.319 0v2.989a.66.66 0 0 1-.659.659",
    transform: "translate(-7930.519 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13799",
    d: "M8082.6 901.692a.66.66 0 0 1-.659-.659v-2.989a.66.66 0 0 1 1.319 0v2.989a.66.66 0 0 1-.66.659",
    transform: "translate(-7971.682 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13800",
    d: "M8126.051 901.692a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.319 0v2.989a.66.66 0 0 1-.66.659",
    transform: "translate(-8012.844 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13801",
    d: "M8169.5 901.692a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.318 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-8054.006 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13802",
    d: "M8212.96 901.692a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.318 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-8095.169 754.862)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13803",
    d: "M7864.711 785.06a.66.66 0 0 1-.66-.659v-2.99a.66.66 0 0 1 1.319 0v2.99a.66.66 0 0 1-.659.659",
    transform: "translate(-7765.29 865.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13804",
    d: "M7908.165 785.06a.659.659 0 0 1-.659-.659v-2.99a.659.659 0 0 1 1.319 0v2.99a.66.66 0 0 1-.66.659",
    transform: "translate(-7806.453 865.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13805",
    d: "M7864.711 886.7a.66.66 0 0 1-.66-.659v-2.989a.66.66 0 0 1 1.319 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-7765.29 769.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13806",
    d: "M7908.165 886.7a.659.659 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.319 0v2.989a.66.66 0 0 1-.66.659",
    transform: "translate(-7806.453 769.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13807",
    d: "M8300.48 785.06a.66.66 0 0 1-.659-.659v-2.99a.659.659 0 1 1 1.318 0v2.99a.659.659 0 0 1-.659.659",
    transform: "translate(-8178.072 865.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13808",
    d: "M8343.936 785.06a.66.66 0 0 1-.659-.659v-2.99a.66.66 0 0 1 1.319 0v2.99a.66.66 0 0 1-.66.659",
    transform: "translate(-8219.235 865.341)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13809",
    d: "M8300.48 886.7a.66.66 0 0 1-.659-.659v-2.989a.659.659 0 1 1 1.318 0v2.989a.659.659 0 0 1-.659.659",
    transform: "translate(-8178.072 769.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13810",
    d: "M8343.936 886.7a.66.66 0 0 1-.659-.659v-2.989a.66.66 0 0 1 1.319 0v2.989a.66.66 0 0 1-.66.659",
    transform: "translate(-8219.235 769.067)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13812",
    d: "M8063.385 236.667a.66.66 0 0 1-.646-.793l2.189-10.585a.659.659 0 1 1 1.292.267l-2.189 10.586a.66.66 0 0 1-.645.526",
    transform: "translate(-7953.483 1392)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13813",
    d: "M8106.479 236.667a.66.66 0 0 1-.646-.526l-2.188-10.586a.659.659 0 1 1 1.291-.267l2.189 10.585a.66.66 0 0 1-.646.793",
    transform: "translate(-7992.232 1392)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13814",
    d: "M8059.1 1065.323h-5.582a.66.66 0 0 1-.659-.659v-8.242a.66.66 0 0 1 .659-.659h5.582a.659.659 0 0 1 .659.659v8.242a.659.659 0 0 1-.659.659m-4.922-1.319h4.263v-6.923h-4.263z",
    transform: "translate(-7944.135 604.839)",
    style: {
      fill: "#313280"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMobile);
export default __webpack_public_path__ + "static/media/chartMobile.23a925b230beb791595dde5c98d14643.svg";
export { ForwardRef as ReactComponent };